import React from "react";
import '../Styles/StaffPage1.scss';

function StaffPage1() {
   return(
      <div className='staffPage1Content'>
         <div className="staffPage1Container">
            <div className="staffPage1Title">
               Meet Our Staff
            </div>
            <div className="staffPage1Description">
               Camp Connect's permanent staff is dedicated to seeing campers' lives changed <br></br>
               and churches strengthened by providing the very best camp experience possible. <br></br>
               They are here to serve campers and churches and organize the year-round camps <br></br>
               and retreats, schedule camp speakers. They also oversee the upkeep of camp facilites <br></br>
               while maintianing the camp vision and purpose.
            </div>
         </div>
      </div>
   )
}
export default StaffPage1;
